/**
 * Footer ,  güven şeridi, link düzeltmeleri, başlık cilası, mobil sınıf
 */
(function () {
  const FAQ_OLD = '/pages/faq'
  const FAQ_NEW = '/pages/haufig-gestellte-fragen-faq'

  const HEADING_MAP = {
    Hauptmenü: 'Shop & Kategorien',
    Fußzeilenmenü: 'Rechtliches',
  }

  function fixFaqLinks(root) {
    root.querySelectorAll(`a[href="${FAQ_OLD}"], a[href*="/pages/faq"]`).forEach((a) => {
      if (a.getAttribute('href') === FAQ_OLD || a.getAttribute('href')?.endsWith('/pages/faq')) {
        a.setAttribute('href', FAQ_NEW)
      }
    })
  }

  function replaceHeadingText(node, from, to) {
    if (!node) return
    for (const child of node.childNodes) {
      if (child.nodeType === Node.TEXT_NODE && child.textContent?.trim() === from) {
        child.textContent = to
      }
    }
    if (node.textContent?.trim() === from) node.textContent = to
  }

  function polishMenuHeadings(footer) {
    footer.querySelectorAll('.menu__heading__default, .menu__heading__accordion').forEach((el) => {
      const raw = el.textContent?.replace(/\s+/g, ' ').trim() ?? ''
      for (const [from, to] of Object.entries(HEADING_MAP)) {
        if (raw.startsWith(from)) {
          replaceHeadingText(el, from, to)
          const aria = el.closest('.menu__details')?.querySelector('nav')
          if (aria) aria.setAttribute('aria-label', to)
        }
      }
    })
  }

  function removeDuplicateLabels(footer) {
    footer.querySelectorAll('.group-block-content').forEach((col) => {
      const text = col.querySelector(':scope > .text-block, :scope > rte-formatter.text-block')
      const menu = col.querySelector(':scope > accordion-custom.menu')
      if (text && menu) text.remove()
    })
  }

  function setupMobileAccordions(footer) {
    if (!window.matchMedia('(max-width: 989px)').matches) return
    footer.querySelectorAll('.menu__details').forEach((details, i) => {
      if (i === 0) details.setAttribute('open', '')
      else details.removeAttribute('open')
    })
  }

  function injectTrustBar() {
    const footer = document.querySelector('footer')
    if (!footer || document.querySelector('.fm-footer-trust')) return

    const bar = document.createElement('div')
    bar.className = 'fm-footer-trust'
    bar.setAttribute('role', 'contentinfo')
    bar.innerHTML =
      '<span><strong>✓</strong> Versand aus Deutschland</span>' +
      '<span><strong>✓</strong> 30 Tage Rückgabe</span>' +
      '<span><strong>✓</strong> Sichere Zahlung</span>' +
      '<span><strong>✓</strong> Kundenservice: <a href="mailto:info@formeya.de">info@formeya.de</a></span>'

    footer.insertBefore(bar, footer.firstChild)
  }

  function injectLegalLine(footer) {
    const utilities = footer.querySelector('.footer-utilities')
    if (!utilities) return

    const inner =
      '<p class="fm-footer-legal__line">' +
      '<span><strong>Formeya</strong>, eine Marke der <strong>ForNest GmbH</strong></span>' +
      '<span>Gewerbestraße 45, 59192 Bergkamen</span>' +
      '<span><a href="mailto:info@formeya.de">info@formeya.de</a></span>' +
      '<span><a href="tel:+4917684290443">+49 176 84290443</a></span>' +
      '</p>'

    let legal = footer.querySelector('.fm-footer-legal')
    if (legal) {
      legal.innerHTML = inner
      return
    }

    legal = document.createElement('div')
    legal.className = 'fm-footer-legal'
    legal.innerHTML = inner
    utilities.insertBefore(legal, utilities.firstChild)
  }

  function fixBrandLegalName(root) {
    root.querySelectorAll('footer p, footer .text-block, footer rte-formatter').forEach((el) => {
      const html = el.innerHTML
      if (/Fornest GmbH/i.test(html)) {
        el.innerHTML = html.replace(/Fornest GmbH/gi, 'ForNest GmbH')
      }
    })
  }

  function injectCertBadges(footer) {
    if (footer.querySelector('.fm-footer-certs')) return
    const brandCol = footer.querySelector(
      '.footer-content > .group-block:first-child .group-block-content',
    )
    if (!brandCol) return

    const tpl = document.getElementById('fm-footer-certs-tpl')
    if (tpl && 'content' in tpl) {
      brandCol.appendChild(tpl.content.firstElementChild.cloneNode(true))
      return
    }

    const certs = document.createElement('div')
    certs.className = 'fm-footer-certs'
    certs.setAttribute('role', 'navigation')
    certs.setAttribute('aria-label', 'Zertifikate und Qualitätsnachweise')
    certs.innerHTML =
      '<p class="fm-footer-certs__head">Qualitätsnachweise</p>' +'<p class="fm-footer-certs__note">Partner- und Produktionszertifikate unserer Lieferanten. Gilt nicht automatisch für jedes Produkt.</p>' +
      '<div class="fm-footer-certs__grid">' +
      '<a class="fm-footer-certs__link" href="/pages/zertifikate#cert-oeko-tex">' +
      '<img src="/cdn/shop/files/oeko-tex-standard-100-zertifikat.webp?width=80" alt="" width="24" height="24" loading="lazy">' +
      '<span>OEKO-TEX®</span></a>' +
      '<a class="fm-footer-certs__link" href="/pages/zertifikate#cert-iso-9001">' +
      '<img src="/cdn/shop/files/iso-9001-qualitaetsmanagement-zertifikat.webp?width=80" alt="" width="24" height="24" loading="lazy">' +
      '<span>ISO 9001</span></a>' +
      '<a class="fm-footer-certs__link fm-footer-certs__link--all" href="/pages/zertifikate">' +
      '<span class="fm-footer-certs__plus" aria-hidden="true">+9</span>' +
      '<span>Alle Zertifikate</span></a>' +
      '</div>'
    brandCol.appendChild(certs)
  }

  function fixCopyright() {
    const year = String(new Date().getFullYear())
    document.querySelectorAll('footer .footer-utilities__text, footer [class*="copyright"]').forEach((el) => {
      const t = el.textContent ?? ''
      if (/©\s*20\d{2}/.test(t) && !t.includes(year)) {
        el.textContent = t.replace(/©\s*20\d{2}/, `© ${year}`)
      }
    })
  }

  function fixAgencyCredit(root) {
    root.querySelectorAll('a[href*="growaydigital"], a[href*="applytogerman"]').forEach((a) => {
      if (/groway/i.test(a.getAttribute('href') ?? '') || /groway/i.test(a.textContent ?? '')) {
        a.setAttribute('href', 'https://applytogerman.com')
        a.textContent = 'ApplyToGerman'
      }
    })
    root.querySelectorAll('footer p, footer em').forEach((el) => {
      if (/groway/i.test(el.textContent ?? '')) {
        el.innerHTML = el.innerHTML
          .replace(/growaydigital\.com/gi, 'applytogerman.com')
          .replace(/Groway Digital/gi, 'ApplyToGerman')
      }
    })
  }

  function fixSocialLinks(root) {
    root.querySelectorAll('a[href*="instagram.com/forumtekstil"]').forEach((a) => {
      a.setAttribute('href', 'https://www.instagram.com/formeya.de')
      const label = a.getAttribute('aria-label')
      if (label && /forumtekstil/i.test(label)) {
        a.setAttribute('aria-label', label.replace(/forumtekstil/gi, 'formeya.de'))
      }
    })
  }

  function boot() {
    const footer = document.querySelector('footer')
    if (!footer) return
    footer.classList.add('fm-footer')
    injectTrustBar()
    injectLegalLine(footer)
    injectCertBadges(footer)
    removeDuplicateLabels(footer)
    polishMenuHeadings(footer)
    setupMobileAccordions(footer)
    fixBrandLegalName(footer)
    fixFaqLinks(document)
    fixSocialLinks(document)
    fixCopyright()
    fixAgencyCredit(document)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  window.matchMedia('(max-width: 989px)').addEventListener('change', boot)

  new MutationObserver(() => {
    fixFaqLinks(document.body)
    fixSocialLinks(document.body)
    const footer = document.querySelector('footer.fm-footer')
    if (footer) polishMenuHeadings(footer)
  }).observe(document.body, { childList: true, subtree: true })
})()
